import axios from "axios";
import config from "../config";
import { loaderService } from "./LoaderService";
import NotificationService from "../components/Utils/NotificationService"; // Import NotificationService

let notificationDisplayed = false; // Track if a notification is currently displayed

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL, // API base URL
  timeout: 600000, // Request timeout (optional)
});

// Define public (whitelisted) APIs
const PUBLIC_API_LIST = ["/login", "/sign-up", "/validate-email"];

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.skipLoader) {
      loaderService.showLoader();
    }
    // Check if the request URL matches any whitelisted API
    const isPublicAPI = PUBLIC_API_LIST.some((endpoint) =>
      config.url.includes(endpoint)
    );

    // If not a public API, add the Authorization header
    if (!isPublicAPI) {
      let token = localStorage.getItem("authToken"); // Replace with your token storage logic
      if (token) {
        token = token.replace(/^"(.*)"$/, "$1");
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    loaderService.hideLoader();
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor for handling global responses
axiosInstance.interceptors.response.use(
  (response) => {
    loaderService.hideLoader();
    notificationDisplayed = false; // Reset notification flag on success
    return response;
  },
  (error) => {
    loaderService.hideLoader();

    // Handle 401 Unauthorized globally
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized access - redirecting to login");
      localStorage.removeItem("authToken"); // Clear the token
      localStorage.removeItem("user"); // Clear the user data
      window.location.href = "/login"; // Redirect to login page
    } else if (!notificationDisplayed) {
      // Show a notification for other errors if none is currently displayed
      notificationDisplayed = true;
      NotificationService.error(
        error.response?.data?.message || "Something went wrong! Please try again later"
      );
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
